import { queryOptions, useQuery } from "@tanstack/react-query";
import { type Api, getExerciseCategories } from "api-client";

export const exerciseCategoriesQueryKey = ["exercise", "categories"] as const;

export function exerciseCategoriesQueryOptions() {
  return queryOptions({
    queryKey: exerciseCategoriesQueryKey,
    queryFn: () => {
      return getExerciseCategories().then((res) => res.data.data);
    },
    // Categories are reference data that effectively never changes.
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

const EMPTY_CATEGORIES: Api.GetExerciseCategories.Output.Self = [];

export function useExerciseCategories(): Api.GetExerciseCategories.Output.Self {
  const query = useQuery(exerciseCategoriesQueryOptions());
  return query.data ?? EMPTY_CATEGORIES;
}
